import React from 'react'
import PropTypes from 'prop-types'

const Header = props => (
  <header className={`${props.className} header`}>
    {props.children}
  </header>
)
export default Header

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.array,
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Header.js